(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_5ecef2d"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('euphra-stock-badge')) {
    class EuphraStockBadge extends HTMLElement {
      connectedCallback() {
        document.addEventListener('variant:update', this.updateAvailability);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.updateAvailability);
      }

      updateAvailability = (event) => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const available = event.detail?.resource?.available === true;
        const updatedBadge = event.detail?.data?.html?.querySelector(
          'euphra-stock-badge[data-product-id="' + this.dataset.productId + '"]'
        );
        const updatedMessage = updatedBadge?.querySelector('[data-stock-message]');
        const currentMessage = this.querySelector('[data-stock-message]');
        this.hidden = !available || !updatedMessage;
        if (updatedMessage && currentMessage) {
          currentMessage.replaceWith(updatedMessage.cloneNode(true));
        }
        this.querySelectorAll('[data-stock-dot]').forEach((element) => {
          element.hidden = !available;
        });
      };
    }
    customElements.define('euphra-stock-badge', EuphraStockBadge);
  }
  } catch(e) { console.error(e); }
})();

})();
